import { render, staticRenderFns } from "./SfTableHeading.vue?vue&type=template&id=eaeab72e&"
import script from "./SfTableHeading.vue?vue&type=script&lang=js&"
export * from "./SfTableHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports